import { connect } from 'react-redux'
import { getPostDischarges180dList } from '../actions/actions-postdischarges'
import { getProgramsAssignedToLoginList } from '../actions/actions-programs'
import PostDischarges180d from '../views/PostDischarges/postdischarges180d'
const mapStateToProps = (state, ownProps) => {
  return {
    parentProps: ownProps,
    postdischarges: state.postdischargesR.dataList,
    programsAssigned: state.programsR.programsassignedtologin
  }
}
const mapDispatchToProps = dispatch => {
  return {
    getPostDischarges: loginID => {
      dispatch(getPostDischarges180dList(loginID))
    },
    getProgramsAssignedToLoginList: id => {
      dispatch(getProgramsAssignedToLoginList(id))
    }
  }
}
const PostDischarge180dListContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(PostDischarges180d)
export default PostDischarge180dListContainer
